import { render, staticRenderFns } from "./AegTabs.vue?vue&type=template&id=7330e3d7"
import script from "./AegTabs.vue?vue&type=script&lang=js"
export * from "./AegTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports